import React, { useEffect } from "react";

import {
  useRecoilState,
  useRecoilStateLoadable,
  useSetRecoilState,
} from "recoil";
import {
  aspectType,
  asyncSearchAspect,
  currentAspectSelected,
  selectedAspect,
} from "lib/store/dashboard";
import { aspectPageState } from "lib/store/sentiment";

import { SentimentStackedBarChart } from "components/atom/SentimentStackedBarChart";

import "./StackedBarChart.scss";

export type StackedBarChartProps = aspectType & {
  cx?: string;
};

export const StackedBarChart: React.FC<StackedBarChartProps> = ({
  cx = "",
  aspect,
  negative,
  positive,
  neutral,
}) => {
  const [page, setPage] = useRecoilState(aspectPageState);
  const setCurrentData = useSetRecoilState(currentAspectSelected);
  const [curAspect, setCurAspect] = useRecoilState(selectedAspect);
  const [{ state, contents }, setList] = useRecoilStateLoadable(
    asyncSearchAspect({ page, aspect: curAspect ?? "" })
  );

  useEffect(() => {
    // 랜더링 횟수를 줄이기 위해서 현재 aspect와 컴포넌트의 aspect가 같은 경우에만 list를 세팅해줌.
    if (state === "hasValue" && curAspect === aspect) {
      setList((list) => ({
        ...list,
        ...contents,
      }));
    }
  }, [curAspect, state, aspect, contents, setList]);

  return (
    <div
      className={`StackedBarChart ${
        curAspect === aspect ? "active" : ""
      } ${cx}`}
      onClick={async () => {
        await setCurAspect(aspect);
        await setPage(1);
        await setCurrentData({
          idx: 0,
          id: 0,
          job: 0,
          plain_text: "",
          created_at: "1970-01-01",
          result: {
            aspect: "",
            sentiment: "",
            aspect_score: 0.0,
            sentiment_score: 0.0,
          },
        });
      }}
    >
      <SentimentStackedBarChart
        aspect={aspect}
        positive={positive}
        negative={negative}
        neutral={neutral}
      />
    </div>
  );
};
